import { EmployeesService } from '../../services/employees.service';
import { DeclarationService} from '../../services/declarations.service';
import { IShift, ShiftService } from '../../services/shifts.service';
import * as moment from 'moment';
import { AuthService } from "../../authorization/services/index";
import { teamsItemComponent } from '../crm/teams/teams.item.component';

class IShiftTeam {
    id: string;
    name: string;
    account: string;
    location: string;
    invoiceNumber: string;
}


class ScheduleDeclarationController implements ng.IComponentController {
    private onChange: any;
    private employeeSummary: any;
    private shift: IShift;
    private moment: any;
    private startDate: any;
    private endDate: any;
    isZZP: any = false;
    invoiceMonthly: any = false;
    invoicenumber: any;
    declarationstoSend: { count: number; totalHours: number; countShifts: number; 'teams' : IShiftTeam[] };

    constructor(
        private DeclarationService: DeclarationService,
        private EmployeesService: EmployeesService,
        private $stateParams: ng.ui.IStateParamsService
    ) {
        'ngInject';
    }

    public $onInit = () => {
        
        this.EmployeesService.getIsZZP().then((value) => {
            this.isZZP = value.zzp;
            this.invoiceMonthly = value.invoiceMonthly;

            this.moment = require('moment');
            if (this.$stateParams["start"]) {
                if( this.invoiceMonthly) {
                    this.startDate = this.moment(this.$stateParams["start"]).startOf('month').toDate();
                    this.endDate = this.moment(this.$stateParams["start"]).endOf('month').toDate();
                }else {
                    this.startDate = this.moment(this.$stateParams["start"]).startOf('isoweek').toDate();
                    this.endDate = this.moment(this.$stateParams["start"]).endOf('isoweek').toDate();
                }
            
            } else {
                if(this.invoiceMonthly) {
                this.startDate = this.moment().startOf('month').toDate();
                this.endDate = this.moment().endOf('month').toDate();
                } else {
                    this.startDate = this.moment().startOf('isoweek').toDate();
                    this.endDate = this.moment().endOf('isoweek').toDate();
                }
            }

            this.getDeclartions();
        });
    } 

    public getDeclartions = () => {
       
        this.EmployeesService.customAll('employeeSummary', {from: moment(this.startDate).format("YYYY-MM-DD HH:mm"), till: moment(this.endDate).format("YYYY-MM-DD HH:mm")}).then((employeeSummary: any) => {
            this.employeeSummary = employeeSummary[0];

            this.declarationstoSend = {'count': 0, 'totalHours': 0, 'countShifts' : 0, 'teams' : []};

            this.employeeSummary.shifts.forEach(shift => {
                this.declarationstoSend.countShifts++;
                shift.declarations.forEach(declaration => {
                    if(declaration.status <= 1){
                        this.declarationstoSend.count++;
                        this.declarationstoSend.totalHours = this.declarationstoSend.totalHours + declaration.duration;

                        if(!this.declarationstoSend.teams.find(t => t.id == shift.teamId)) {
                            this.declarationstoSend.teams.push({
                                id: shift.teamId,
                                name: shift.teamName,
                                location: shift.teamLocationName,
                                account: shift.teamLocationAccountName,
                                invoiceNumber: ''
                            });
                        }
                    }
                });
            });

            
        })
  
    }

    public postConfirm = () => {
       
        this.DeclarationService.confirm({teams: this.declarationstoSend.teams, from: moment(this.startDate).format("YYYY-MM-DD HH:mm"), till: moment(this.endDate).format("YYYY-MM-DD HH:mm")}).then((data: any) => {
            this.getDeclartions();
            (<any>$('#sendDeclartionsFormModal')).modal('hide');
        })
  
    }

    prevWeek() {
        if(this.invoiceMonthly){
            this.startDate = this.moment(this.startDate).add(-1, 'month').startOf('month').toDate();
            console.log(this.startDate)
            this.endDate = this.moment(this.endDate).add(-1, 'month').endOf('month').toDate();
            console.log(this.endDate)
        } else {
            this.startDate = this.moment(this.startDate).add(-7, 'day').toDate();
            this.endDate = this.moment(this.endDate).add(-7, 'day').toDate();
        }
      
        this.getDeclartions();
    }

    nextWeek() {
        if(this.invoiceMonthly){
            this.startDate = this.moment(this.startDate).add(1, 'month').startOf('month').toDate();
            this.endDate = this.moment(this.endDate).add(1, 'month').endOf('month').toDate();
        } else {
            this.startDate = this.moment(this.startDate).add(7, 'day').toDate();
            this.endDate = this.moment(this.endDate).add(7, 'day').toDate();
        }
        this.getDeclartions();
    }

    sendZPPDeclarations() {
        (<any>$('#sendDeclartionsFormModal')).modal('show');
    }

    
}

export const scheduleDeclarationComponent: ng.IComponentOptions = {
    bindings: {
        onChange: '&',

    },
    controller: ScheduleDeclarationController,
    template: <string>require('./schedule.declaration.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/schedule/schedule.declaration.component.ts